export const text = {
  view: 'Vista'
};
